import { dateRangeFromISO, getDateRange } from "@app/lib/date-range";
import MrrPage, { mrrQuery } from "@app/pages/mrr/mrr-page";
import type { mrrPage_Query } from "@app/queries/mrrPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/mrr")({
  loader: () =>
    loadQuery<mrrPage_Query>(
      environment,
      mrrQuery,
      { from: dateRangeFromISO(getDateRange()) ?? undefined },
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("MRR"),
  component: MrrRoute,
});

function MrrRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading MRR analysis</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Decomposing MRR movements...</div>
        }
      >
        <MrrPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
